import React, { useState, useEffect, useContext,  useCallback, useMemo, useRef } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { ActivityRingsBase } from './graphs/activityRings/ActivityRings';
import ProgressBar from './graphs/progressBar/ProgressBar';
import { classNameTriskeleParser } from '../../../utilities/customStyles';
import DailyDashboardSkeleton from './skeleton/DailyDashboardSkeleton';
import globalContext from '../../../context/GlobalContext';
import DashboardAccess from '../../../dataAccess/DashboardAccess';
import PieFactory from './graphs/activityRings/PieFactory';
import { THEMES } from './graphs/activityRings/Themes';
import { setUserProfile } from '../../../redux/actions/userProfileAction';
import { Body4400N, Body4400U } from '../../../utilities/generatedClasses';
import { useNavigate } from 'react-router-dom';

const progressBarInnerText = (bar) => {
  if (bar.VisualNameFour === 'Span Bar') {
    return (
      <span className="bar-infront-text">
        <span className={`${bar.triskeleClass['text start']}`}>{`${bar.HighRcmndtnQty}`}</span>
      </span>
    );
  }
  return (
    <span className="bar-infront-text">
      <span className={`${bar.triskeleClass['text start']}`}>{`${bar.HighActualQty}`}</span>{' '}
      <span className={`${bar.triskeleClass['text end']}`}>{`/ ${bar.HighRcmndtnQty}`}</span>
    </span>
  );
};

const progressBarCenterText = (bar) => {
  if (bar.VisualNameFour === 'Span Bar') {
    return (
      <span className="bar-infront-text">
        <span className={`${bar.triskeleClass['text end']}`}>
          {
            bar.LowActualQty && bar.LowActualQty !== bar.HighActualQty ? (`${bar.LowActualQty}-`) : ''
          }
          {
            bar.HighActualQty ? (`${bar.HighActualQty}`) : ''
          }
        </span>
      </span>
    );
  }
  return null;
};

const progressBarLeftText = (bar) => {
  if (bar.VisualNameFour === 'Span Bar') {
    return (
      <span className="bar-infront-text">
        <span className={`${bar.triskeleClass['text start']}`}>{`${bar.LowRcmndtnQty}`}</span>
      </span>
    );
  }
  return null;
};


const loadMeasureBars = (bars, measureName, context, navigate, clientId) => {
  const goToChart = (reportUrl, reportName) => {
    // context.navigation.push('/home/analytics/chart', { reportName, reportUrl });
  };
  const openProfile = (provider) => {
    navigate(`/home/userprofile?providerId=${provider.ProviderId}&clientId=${clientId}`, {
      state: { providerId: provider.ProviderId, clientId: clientId }
    });
  };
     let _bars = bars && bars.length >  0 ? bars
          .filter(
            bar => bar.VisualTypeFour === measureName || bar.VisualTypeSix === measureName
          ) : [];
  return (
    <span>
      {' '}
      {_bars.length > 0
        && _bars
          .map(bar => (
            <div className="dashboard-left-side-main-section-measure" key={bar.MeasureName}>
              <div className="dashboard-left-side-main-section-measure-box" style={{ marginBottom: '12px', paddingLeft: '10px'}}>
                <span
                  className={`${bar.triskeleClass.heading} measure-title`}
                  onClick={() => goToChart(bar.ReportURL, bar.MeasureName)}
                  aria-hidden="true"
                  style={{ display: 'inline-block', marginTop:'8px', textAlign: 'center'}}
                >
                  {bar.MeasureName}
                </span>
                <div className={`icon-background  ${bar.triskeleClass.circle} `} style={{float: 'right', margin: 'unset'}}>
                  <div className={`${bar.triskeleClass.icon} icon-metric`} />
                </div>
              </div>
              <ProgressBar
                rightText={progressBarInnerText(bar)}
                centerText={progressBarCenterText(bar)}
                leftText={progressBarLeftText(bar)}
                start={bar.StartProgressBarPctCmpltn}
                progress={bar.EndProgressBarPctCmpltn}
                height={26}
                filledClass={bar.triskeleClass.filled}
                unfilledClass={bar.triskeleClass.unfilled}
              />
              <span className="dashboard-left-side-main-section-measure-bottom-text">
                <span className={`${Body4400N}`}>Set by{' '}</span>
                <span
                  onClick={() => bar.triskeleClass['ProfileClickeable'] ? openProfile(bar) : null}
                  className={`${bar.triskeleClass['text assign']} ${bar.triskeleClass['ProfileClickeable'] ? 'profile-user-assign' : ''}`}
                  aria-hidden="true"
                >
                  {bar.ProviderName}
                </span>{' '}
                <span className={`${Body4400N}`}>on {bar.RcmndtnAsgnmtDate}</span>
              </span>
            </div>
          ))}

          {_bars.length == 0 && (

           <div className="SpanBarBarUnfilledPhysiologic dashboard-left-side-main-section-measure" >
              <span className="bar-infront-text" 
              style={{height: '40px !important', position: 'absolute', left: '50%', transform: 'translate(-50%, -5%)', display: 'flex', alignItems: 'center', marginTop: 'calc(-2px + 0.5vw)'}}
            >
                <span className="bar-infront-text">
                  <span className="SpanBarText2Physiologic" style={{fontWeight: '500 !important'}}>No Recommendations</span>
                </span>
              </span>
            </div>
          )}
    </span>
  );
};

const DailyView = (props) => {
  const navigate = useNavigate();
  const [dailyDashboard, setDailyDashboard] = useState(null);
  const topFilterData = useSelector(state => state.widgetFiltes);
  const context = useContext(globalContext);
  const { clientId } = props;
  function sortMeasuresCategories(a, b) {
    if (parseInt(a.MeasureCtgySortOrdr, 0) < parseInt(b.MeasureCtgySortOrdr, 0)) {
      return -1;
    }
    if (parseInt(a.MeasureCtgySortOrdr, 0) > parseInt(b.MeasureCtgySortOrdr, 0)) {
      return 1;
    }
    return 0;
  }


  const formatRings = (data) => {
    let rings = [];

    rings = data.map((ring) => {
      const createClass = classNameTriskeleParser.bind(this, ring.VisualNameOne, ring.VisualTypeOne, 'Ring');
      const filterRings = topFilterData.widgetFiltes.includes(ring.MeasureCtgyName) ? (Number(ring.RingPctCmpltn) / 100) : 0.00;

      return {
        value: filterRings,
        triskeleClass: {
          filled: createClass('Filled'),
          unfilled: createClass('Unfilled')
        }
      };
    });

    while (rings.length < 4) {
      rings.push({
        value: 0.000,
        triskeleClass: {
          filled: 'ProgressRingRingFilledActivity',
          unfilled: 'ProgressRingRingUnfilledActivity'
        }
      });
    }

    return rings;
  };

  const formatHeaders = (data) => {
    let headers = [];
    headers = data.map((header) => {
      const createClass = classNameTriskeleParser.bind(this, header.VisualNameTwo, header.VisualTypeTwo, 'Text');
      return {
        title: header.MeasureCtgyName,
        functionality: header.VisualFnctn2,
        triskeleClass: {
          text: createClass()
        },
      };
    });

    return headers;
  };

  const formatBars = (data) => {
    let bars = [];

    bars = data.map((bar) => {
      bar.triskeleClass = {};

      if (bar.VisualNameThree && bar.VisualTypeThree) {
        const headingClass = classNameTriskeleParser.bind(this, bar.VisualNameThree, bar.VisualTypeThree, 'Text');
        bar.triskeleClass.heading = headingClass();
      }

      if (bar.VisualNameFour && bar.VisualTypeFour) {
        const barsClass = classNameTriskeleParser.bind(this, bar.VisualNameFour, bar.VisualTypeFour);
        bar.triskeleClass.filled = barsClass('Bar', 'Filled');
        bar.triskeleClass.unfilled = barsClass('Bar', 'Unfilled');
        bar.triskeleClass['text start'] = barsClass('Text1');
        bar.triskeleClass['text end'] = barsClass('Text2');
      }

      if (bar.VisualNameFive && bar.VisualTypeFive) {
        const assignyClass = classNameTriskeleParser.bind(this, bar.VisualNameFive, bar.VisualTypeFive, 'Text');
        bar.triskeleClass['text assign'] = assignyClass();
      }

      if (bar.VisualNameSix && bar.VisualTypeSix) {
        const circleClass = classNameTriskeleParser.bind(this, bar.VisualNameSix, bar.VisualTypeSix);
        bar.triskeleClass.icon = circleClass('Icon');
        bar.triskeleClass.circle = circleClass('Circle');
      }

      bar.EndProgressBarPctCmpltn = parseInt(bar.EndProgressBarPctCmpltn.toString().replace('%', ''), 0);
      if (bar.StartProgressBarPctCmpltn) {
        bar.StartProgressBarPctCmpltn = parseInt(bar.StartProgressBarPctCmpltn.toString().replace('%', ''), 0);
      }
      bar.triskeleClass.ProfileClickeable = bar.VisualFnctnThree === "Unclickable"; 

      return bar;
    });

    return bars;
  };


  const dailyReqKeyRef = useRef(null);
  const reqGenRef = useRef(0);

  const selectedDateKey = useMemo(() => {
    const d = topFilterData?.selectedDate;
    if (!d) return null;
    return `${clientId}|${String(d)}`;
  }, [clientId, topFilterData?.selectedDate]);

  const fetchDailyDashboard = useCallback(() => {
    const selectedDate = topFilterData?.selectedDate;
    if (!selectedDate) return;

    // Deduplicate: skip if already fetched for this exact date+client
    if (dailyReqKeyRef.current === selectedDateKey) return;
    dailyReqKeyRef.current = selectedDateKey;

    // Generation counter: discard responses from superseded requests
    const gen = ++reqGenRef.current;
    setDailyDashboard(null);

    DashboardAccess.getDailyDashboard(clientId, selectedDate)
      .then((response) => {
        if (gen !== reqGenRef.current) return; // stale response — a newer request is in flight

        if (response.status === 204) {
          const emptyHeaders = ['Activity', 'Nutrition', 'Sleep', 'Physiologic'].map(el => ({
            title: el,
            functionality: 'None',
            triskeleClass: { text: 'Heading4TextMiddleNavy' }
          }));
          setDailyDashboard({ rings: formatRings([]), headers: emptyHeaders, bars: [] });
          return;
        }

        const { data } = response;
        const daily = { rings: [], headers: [], bars: [] };

        const headerAndRings = data
          .filter(el => el.PrcsParmtrValueOne === 'Header & Ring')
          .sort(sortMeasuresCategories);

        const measures = data.filter(el => el.PrcsParmtrValueOne === 'Measure');

        daily.rings = formatRings(headerAndRings);
        daily.headers = formatHeaders(headerAndRings);
        daily.bars = formatBars(measures);

        const config = { width: 300, height: 300, ringSize: 15, radius: 30 };

        if (window.innerWidth > 2500) {
          config.width = 750; config.height = 750; config.ringSize = 50;
        } else if (window.innerWidth > 1500) {
          config.width = 550; config.height = 550; config.ringSize = 40;
        } else if (window.innerWidth > 850) {
          config.width = 350; config.height = 350; config.ringSize = 35;
        }

        const itemsNumber = daily.rings.length;
        if (itemsNumber < 7) {
          config.radius = 160 - (itemsNumber * 26);
        } else {
          config.radius = 20;
          config.ringSize -= ((itemsNumber - 7) * 2);
        }

        daily.backPie = PieFactory.create(daily.rings, config.height, config.radius, [0.999, 0.001]);
        daily.frontPie = PieFactory.create(daily.rings, config.height, config.radius);
        daily.selectedTheme = THEMES.dark;
        daily.config = config;

        setTimeout(() => {
          if (gen !== reqGenRef.current) return;
          setDailyDashboard(daily);
        }, 100);
      })
      .catch((error) => {
        if (gen !== reqGenRef.current) return;
        console.error(error);
        dailyReqKeyRef.current = null; // allow retry on next effect
        navigate('/maintenance');
      });
  }, [
    clientId,
    selectedDateKey,
    topFilterData?.selectedDate,
    setDailyDashboard,
    navigate
  ]);

  // Stable reference — only changes when fetchDailyDashboard changes (i.e. date changes)
  const updateDailyRings = useCallback(() => {
    if (window.innerWidth > 1500 && window.innerWidth < 2499 && (window.requestedWidth < 1500 || window.requestedWidth > 2500)) {
      setDailyDashboard(null);
      window.requestedWidth = window.innerWidth;
      fetchDailyDashboard();
    } else if (window.innerWidth > 700 && window.innerWidth < 1500 && (window.requestedWidth < 700 || window.requestedWidth > 1500)) {
      setDailyDashboard(null);
      window.requestedWidth = window.innerWidth;
      fetchDailyDashboard();
    } else if (window.innerWidth > 2500 && window.requestedWidth < 2500) {
      setDailyDashboard(null);
      window.requestedWidth = window.innerWidth;
      fetchDailyDashboard();
    }
  }, [fetchDailyDashboard]);

  useEffect(() => {
    window.requestedWidth = window.innerWidth;
    fetchDailyDashboard();
  }, [fetchDailyDashboard]);

  useEffect(() => {
    window.addEventListener('resize', updateDailyRings);
    return () => window.removeEventListener('resize', updateDailyRings);
  }, [updateDailyRings]);

  const clickOnMeasureHeading = (header, functionality) => {
    navigate('/home/analytics', { headerTitle: header.title });
  };

  return (
    <div className="dashboard-left-side" id="dashboardLeftSide">
      {!dailyDashboard && <DailyDashboardSkeleton />}

      {dailyDashboard && dailyDashboard.rings && dailyDashboard.rings.length > 0 && (
        <ActivityRingsBase data={dailyDashboard} />
      )}
      {dailyDashboard && dailyDashboard.headers
        && dailyDashboard.headers.length > 0
        && dailyDashboard.headers.filter(head => topFilterData.widgetFiltes.includes(head.title)).map(header => (
          <span key={header.title}>
            <span 
              onClick={() => clickOnMeasureHeading(header, header.functionality)
              }
              className={`dashboard-left-side-main-section-header ${header.triskeleClass.text}`}
              aria-hidden="true"
              style={{ marginLeft: '10px' }}
            >
              {header.title}
            </span>
            <div>
              {loadMeasureBars(dailyDashboard.bars, header.title, context, navigate, clientId)}
            </div>
          </span>
        ))}
    </div>
  );
};
export default DailyView;
